import React from 'react';

/**
 * The claw motif: three parallel red strokes at -24deg with a soft glow.
 * Place inside a positioned parent; position with className/style.
 * `grow` makes the strokes rake down in sequence once a parent Reveal
 * (or this element) gets `is-visible`.
 */
export default function Claws({ className = '', style, grow = true, tone = 'red', thin = false }) {
  return (
    <div
      aria-hidden="true"
      className={`pnp-claw${thin ? ' pnp-claw-thin' : ''}${tone === 'gold' ? ' pnp-claw-gold' : ''} ${className}`.trim()}
      data-grow={grow ? '' : undefined}
      style={style}
    >
      <span />
      <span />
      <span />
    </div>
  );
}
